import createFetchClient, { type Client, type ClientOptions } from 'openapi-fetch'
import type { paths } from '../../types.cloud.d.ts'
export type {
    Client as OpenApiClient,
    ClientPathsWithMethod as OpenApiClientPathsWithMethod,
    MaybeOptionalInit as OpenApiMaybeOptionalInit,
    MethodResponse as OpenApiMethodResponse,
} from 'openapi-fetch'

export type NetdataCloudClient = Client<paths>

/**
 * Creates a typed fetch client for the Netdata Cloud API.
 * Quick start:
 *   const cloud = createCloudClient({ baseUrl: "https://app.netdata.cloud" });
 *   const response = await cloud.GET("/api/v3/spaces");
 */
export default function createCloudClient(options: ClientOptions = {}): NetdataCloudClient {
    return createFetchClient<paths>(options)
}
